import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {RouterLink} from "@angular/router";
import {Button, ButtonDirective} from "primeng/button";
import {UserService} from "../../services/user.service";
import {AuthService} from "../../services/auth/auth.service";
import {isNative} from "../../utils";
import {TranslocoPipe} from "@jsverse/transloco";
import {LanguageSwitcherComponent} from "../language-switcher/language-switcher.component";
import {TranslateService} from "../../services/translate.service";

@Component({
  selector: 'footer[homeyFooter]',
  imports: [
    RouterLink,
    Button,
    ButtonDirective,
    TranslocoPipe,
    LanguageSwitcherComponent
  ],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  public readonly showLogin = input<boolean>(false);
  public readonly includeTopPadding = input<boolean>(true);

  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);
  private readonly translateService = inject(TranslateService);

  protected readonly user = this.userService.user;

  protected readonly footerLinks = computed<{ labelKey: string; link: string[] }[]>(() => ([
    { labelKey: 'common.nav.howItWorks',      link: ['/how-it-works'] },
    { labelKey: 'common.nav.commonQuestions', link: ['/common-questions'] },
    { labelKey: 'common.nav.aboutUs',         link: ['/about-us'] },
    { labelKey: 'common.nav.contactUs',       link: ['/contact'] },
    { labelKey: 'common.nav.articles',        link: ['/articles'] },
    { labelKey: 'common.nav.privacy',         link: ['/privacy-policy'] },
    { labelKey: 'common.nav.terms',           link: ['/terms-and-conditions'] },
    { labelKey: 'common.nav.allApartments',   link: this.translateService.language() === 'en' ? ['/apartments'] : ['/es/apartments'] },
  ]));

  onLogoutClick() {
    this.authService.logout();
  }

  protected readonly isNative = isNative;
}
